import { GPanelContactsPermissions } from '../../../../../utils/roles/client-roles';
import { getPermissionsFactory, usePermissions } from './use-permissions';

const permissionsFactory = getPermissionsFactory(GPanelContactsPermissions);

export function useGpanelContactsPermissions() {
  return usePermissions<typeof GPanelContactsPermissions>(
    permissionsFactory,
    'gPanelContactsRoles'
  );
}
